import { CircleDot } from "lucide-react";

const BASE = process.env.PUBLIC_URL || "";

const METHODS = [
  { name: "Visa", file: "visa.svg", size: "h-7" },
  { name: "Maestro", file: "maestro.svg", size: "h-8" },
  { name: "Mastercard", file: "mastercard.svg", size: "h-8" },
  { name: "American Express", file: "amex.svg", size: "h-9" },
  { name: "Stripe", file: "stripe.svg", size: "h-7" },
  { name: "Razorpay", file: "razorpay.svg", size: "h-5", wordmark: true },
  { name: "PayPal", file: "paypal.svg", size: "h-8" },
];

export default function PaymentLogos({ dark = false }) {
  const tileClass = dark
    ? "border-ivory/15 bg-ivory"
    : "border-navy/10 bg-white";

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4" aria-label="Accepted online payment methods">
      {METHODS.map((method) => (
        <div key={method.name} className={`h-16 min-w-0 rounded border flex items-center justify-center gap-2 px-3 ${tileClass}`}>
          <img
            src={`${BASE}/images/payments/${method.file}`}
            alt={method.name}
            className={`${method.size} max-w-full w-auto object-contain`}
          />
          {method.wordmark && <span className="text-sm font-bold text-[#0B72E7]">Razorpay</span>}
        </div>
      ))}
      <div className={`h-16 min-w-0 rounded border flex items-center justify-center gap-1.5 px-3 text-[#343a40] ${tileClass}`} aria-label="Tap Payments">
        <CircleDot size={19} strokeWidth={1.7} />
        <span className="text-xl font-medium leading-none">tap</span>
      </div>
    </div>
  );
}
